import request from '@/utils/request'

export function page(params) {
  return request({
    url: '/api/base/baseCargoSpec/page',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/api/base/baseCargoSpec',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/api/base/baseCargoSpec',
    method: 'put',
    data
  })
}

export function batchDel(ids) {
  return request({
    url: '/api/base/baseCargoSpec/batch',
    method: 'delete',
    data: ids
  })
}

export function getById(id) {
  return request({
    url: '/api/base/baseCargoSpec',
    method: 'get',
    params: {
      id
    }
  })
}

export function groupListOption(params) {
  return request({
    url: '/api/base/baseCargoSpec/groupListOption',
    method: 'get',
    params
  })
}